import { AudienceType } from '@square/dashboard-data/models/squareup/rolodex/group';
import Filter from '@square/dashboard-data/models/squareup/rolodex/filter';
import ListContactsSortType from '@square/dashboard-data/models/squareup/rolodex/list-contacts-sort-type';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  limit: attr(Number),
  pagingKey: attr(String),
  query: attr(String),
  groupToken: repeated(String),
  sortType: attr(ListContactsSortType),
  audienceType: attr(AudienceType),
  manual: attr(Boolean),
  automatic: attr(Boolean),
  contactable: attr(Boolean),
  automaticAvailable: attr(Boolean),
  filters: repeated(Filter)
});